import { render, staticRenderFns } from "./Eye4.vue?vue&type=template&id=3d566113&"
import script from "./Eye4.vue?vue&type=script&lang=js&"
export * from "./Eye4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports